import { useEffect, useRef } from "react"
import { OverlayPanel } from "primereact/overlaypanel"

import PastSellerPOsTransactions from "../../../common/PastSellerPOsTransactions"

import Tooltip from '../../../helpers/Tooltip'

const MaterialsPreviousTransactions = (props) => {
    const { relatedPastSellerPOMaterialTransactions, isPrevSelPOMaterialTransactionsLoading, PMCompanyConfig, tiggerPastTransactions, canApplyPastValues, appliedValue, identifier } = props

    const prevTransactionsPopup = useRef(null)
    const imgRef = useRef(null)

    // useEffect(() => {
    //     console.log("trigger")
    //     imgRef.current.click()
    // }, [tiggerPastTransactions])

    const handlePrevTransctionsClcik = async (e) => {
        prevTransactionsPopup.current.show(e)
    }

    return (
        <div className={`ml-1 mt-3`}>
            <i style={{ fontWeight: 500, fontSize: 15 }}></i>
            <img src="https://procmart-dev.s3.ap-south-1.amazonaws.com/requirementSourceDocument/cd8f578d-93e7-4810-b947-479180a04e33.png" className='material-history-tooltip cursor-pointer mt-2' style={{ width: '1.5rem', height: '1.5rem' }} onClick={(e) => handlePrevTransctionsClcik(e)} ref={imgRef} />
            <Tooltip target=".material-history-tooltip" position="top">
                <span>View past POs for this material</span>
            </Tooltip>
            <OverlayPanel ref={prevTransactionsPopup} className="max-w-max past-transactions-panel p-1 mt-0" visible={tiggerPastTransactions}>
                <PastSellerPOsTransactions
                    pastPOs={relatedPastSellerPOMaterialTransactions}
                    isPrevSelPOMaterialTransactionsLoading={isPrevSelPOMaterialTransactionsLoading}
                    PMCompanyConfig={PMCompanyConfig}
                    canApplyPastValues={canApplyPastValues}
                    handleApplySellerPOPastValues={props.handleApplySellerPOPastValues}
                    identifier={identifier}
                    appliedValue={appliedValue}
                />
            </OverlayPanel>
        </div>
    )
}

export default MaterialsPreviousTransactions